import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Building } from "lucide-react";
import { USER_TYPES } from "./types";

interface Step2Props {
  selectedUserType: string;
  onSelect: (typeId: string) => void;
}

export function Step2UserType({ selectedUserType, onSelect }: Step2Props) {
  return (
    <Card className="border-border bg-gradient-accent">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-foreground">
          <Building className="h-5 w-5 text-primary" />
          What describes you best?
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {USER_TYPES.map((type) => (
            <div
              key={type.id}
              onClick={() => onSelect(type.id)}
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-300 hover:shadow-elegant ${
                selectedUserType === type.id
                  ? "border-primary bg-primary/10"
                  : "border-border bg-background hover:border-primary/50"
              }`}
            >
              <div className="flex items-center gap-3">
                <div className="bg-primary/20 rounded-lg p-2">
                  <type.icon className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground">{type.title}</h3>
                  <p className="text-sm text-muted-foreground">{type.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
